import { BuilderComponent } from '@builder.io/react'
import '../../../../common/components/marketing/text/FAQSection.builder'
import '../../../../common/components/marketing/buttons/LinkButton.builder'
import { styled } from '@/src/stitches.config'

const Wrapper = styled('div', {
    py: 10,
})

type TFAQProps = {
    builderContentJson: any
}

const PGPlusFAQs = ({ builderContentJson }: TFAQProps) => {
    if (!builderContentJson) {
        return <></>
    }

    return (
        <Wrapper>
            <BuilderComponent model={'symbol'} content={builderContentJson} />
        </Wrapper>
    )
}

export default PGPlusFAQs
